export default __webpack_public_path__ + "static/media/kiosk-side-banner.82095076.svg";